import { Conversation } from './types/Conversation';
import { MakeCall } from './createMakeCall';

export interface Payload {
  reason: string;
}

const declineConversation =
  (makeCall: MakeCall) => (conversationId: number, data: Payload) =>
    makeCall<Conversation>(
      'PUT',
      `/api/v2/conversation/${conversationId}/decline`,
      { data },
    );
export { declineConversation };
